import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { catalogQueryOptions } from "@/app/catalog/api/get-catalog";
import { CatalogListSkeleton } from "@/app/catalog/components/catalog-list-skeleton";
import { CatalogList } from "@/app/catalog/list";
import {
  catalogSearchDefaults,
  catalogSearchSchema,
} from "@/app/catalog/search-params";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/catalog"
)({
  validateSearch: zodValidator(catalogSearchSchema),
  search: {
    middlewares: [stripSearchParams(catalogSearchDefaults)],
  },
  component: () => (
    <Suspense fallback={<CatalogListSkeleton />}>
      <CatalogList />
    </Suspense>
  ),
  async beforeLoad(ctx) {
    await requireProjectPermission(ctx, PROJECT.catalog.read);
    ctx.context.queryClient.prefetchQuery(catalogQueryOptions(ctx.params));
  },
  loader: () => ({
    crumb: "End-user dashboard",
  }),
});
